import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './chart.types';
import * as constants from './chart.constants';

export const storeChart = generateStoreResourceAction<types.IChart>(constants.STORE_CHART);
export const clearChart = generateClearResourceAction(constants.CLEAR_CHART);
